// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LC2Y4","content":"styles_content__1TvPK","tableWrap":"styles_tableWrap__19LtG"};